export default __webpack_public_path__ + "static/media/empty.8dccf1aa.svg";